/**
 * Arrow direction
 */
export var ArrowDirection;
(function (ArrowDirection) {
    ArrowDirection["UP"] = "top";
    ArrowDirection["BOTTOM"] = "bottom";
    ArrowDirection["LEFT"] = "left";
    ArrowDirection["RIGHT"] = "right";
})(ArrowDirection || (ArrowDirection = {}));
/**
 * Arrow align
 */
export var ArrowAlign;
(function (ArrowAlign) {
    ArrowAlign["ONE_FIFTH"] = "one-fifth";
    ArrowAlign["ONE_QUARTER"] = "one-quarter";
    ArrowAlign["ONE_THRID"] = "one-thrid";
    ArrowAlign["TWO_FIFTHS"] = "two-fifths";
    ArrowAlign["THREE_FIFTHS"] = "three-fifths";
    ArrowAlign["TWO_THIRDS"] = "two-thirds";
    ArrowAlign["THREE_QUARTERS"] = "three-quarters";
    ArrowAlign["FOUR_FIFTHS"] = "four-fifths";
})(ArrowAlign || (ArrowAlign = {}));
/**
 * Avatar direction
 */
export var AvatarDirection;
(function (AvatarDirection) {
    AvatarDirection["LEFT"] = "left";
    AvatarDirection["RIGHT"] = "right";
})(AvatarDirection || (AvatarDirection = {}));
//# sourceMappingURL=ProductTourProps.js.map